// modifié le 05/04/2017
// import MutationSummary from './mutation_summary.js'

var TreeMirror = (function () {
  window.TataMirror = !window.TataMirror ? [] : window.TataMirror
  window.TataMirror.push(new Date())
  function TreeMirror (root, delegate) {
    // console.log('TreeMirror root', root)
    this.root = root
    this.delegate = delegate
    this.idMap = {}
  }
  TreeMirror.prototype.initialize = function (rootId, children) {
    this.idMap[rootId] = this.root
    for (var i = 0; i < children.length; i++) { this.deserializeNode(children[i], this.root) }
  }
  TreeMirror.prototype.applyChanged = function (removed, addedOrMoved, attributes, text) {
    var _this = this
    // console.log('applyChanged  this :', this)
    // console.log('addedOrMoved', addedOrMoved)
    // console.log('text', text)
    // NOTE: Applying the changes can result in an attempting to add a child
    // to a parent which is presently an ancestor of the parent. This can occur
    // based on random ordering of moves. The way we handle this is to first
    // remove all changed nodes from their parents, then apply.
    addedOrMoved.forEach(function (data) {
      var node = _this.deserializeNode(data)
      var parent = _this.deserializeNode(data.parentNode)
      // var previous = _this.deserializeNode(data.previousSibling)

      if (node.contains(parent) === false &&
                node instanceof window.HTMLElement === true &&
                parent instanceof window.HTMLElement === true &&
                node.parentNode) {
        node.parentNode.removeChild(node)
      }
    })
    removed.forEach(function (data) {
      // console.log('removed : ', data)
      var node = _this.deserializeNode(data)
      // console.log('node : '+node);
      if (node) {
        if (node.parentNode) {
          node.parentNode.removeChild(node)
        }
      }
    })

    addedOrMoved.forEach(function (data) {
      // console.log('addedOrMoved : ', data)
      var node = _this.deserializeNode(data)
      var parent = _this.deserializeNode(data.parentNode)
      var previous = _this.deserializeNode(data.previousSibling)
      // console.log('node', node)
      // console.log('parent', parent)
      try {
      // The node might be a document element which has a parent reference
      // to the last node in the idMap. In this case we will see the error
      // above (see NOTE)
        if (!node.contains(parent) &&
                  (node instanceof window.HTMLElement === true) &&
        // 21.3.2017: In some cases the idMap reports that the parent of the element is for example
        // html comment. In this case we obviously don't want to apply the move so we check
        // here that it is
                  (parent instanceof window.HTMLElement === true)
        ) {
          // console.log('insertBefore ')
          parent.insertBefore(node, previous ? previous.nextSibling : parent.firstChild)
        } else if (
          node instanceof window.HTMLElement &&
          node.nodeName === 'HTML' &&
          _this.root instanceof window.HTMLDocument &&
          _this.root.contains(node) === false
        ) {
          // console.log('appendChild  ')
          _this.root.appendChild(node)
        } else {
          if (parent.nodeName === 'TEXTAREA') {
            // console.log('tree textearea')
            parent.value = data.textContent
            parent.innerHTML = data.textContent
          } else if (parent.nodeName === 'INPUT') {
            // console.log('tree input')
            parent.value = data.textContent
          }
          // console.log('autre : ', parent.nodeName)
        }
      } catch (e) {
        // In some cases it seems that MutationSummary determines the parent
        // of a node incorrectly. Example: <meta> element has parent #document
        // and previousSibling is <html>. When this occurs we receive an error
        // that says 'Only one element is allowed on #document'
        // We probably want to append the node to the sibling
        if (parent instanceof window.HTMLDocument &&
                  previous instanceof window.HTMLElement &&
                  parent.contains(previous)) {
          if (previous.firstChild) { previous.insertBefore(node, previous.firstChild) } else { previous.appendChild(node) }
        }

        // Might still fail but we should call applyChanged inside try...catch
        // anyway
        if (_this.debug) {
          console.log(e)
        }
      }
    })

    // les attributes
    attributes.forEach(function (data) {
      // console.log('attributes : ', data)
      var node = _this.deserializeNode(data)
      Object.keys(data.attributes).forEach(function (attrName) {
        var newVal = data.attributes[attrName]
        // console.log('attrName', attrName)
        if (newVal === null) {
          node.removeAttribute(attrName)
        } else {
          if (attrName === 'innerhtml') {
            node.innerHTML = newVal
          }
          try {
            if (!_this.delegate || !_this.delegate.setAttribute || !_this.delegate.setAttribute(node, attrName, newVal)) {
              node.setAttribute(attrName, newVal)
            }
          } catch (e) {
            // console.log(e)
            // Debug nod e.setAttribute here
          }
        }
      })
    })

    // le contenu text
    text.forEach(function (data) {
      // console.log('text : ', data)
      var node = _this.deserializeNode(data)
      // console.log(node)
      if (node) {
        node.textContent = data.textContent
      }
    })

    removed.forEach(function (node) {
      delete _this.idMap[node.id]
    })
  }

  TreeMirror.prototype.deserializeNode = function (nodeData, parent) {
    // console.log('deserializeNode', nodeData)
    var _this = this
    if (nodeData === null) { return null }

    var node = this.idMap[nodeData.id]
    if (node) { return node }

    var doc = this.root.ownerDocument
    if (doc === null) { doc = this.root }

    switch (nodeData.nodeType) {
      case window.Node.COMMENT_NODE:
        node = doc.createComment(nodeData.textContent)
        break

      case window.Node.TEXT_NODE:
        node = doc.createTextNode(nodeData.textContent)
        break

      case window.Node.DOCUMENT_TYPE_NODE:
        node = doc.implementation.createDocumentType(nodeData.name, nodeData.publicId, nodeData.systemId)
        break

      case window.Node.ELEMENT_NODE:
        if (this.delegate && this.delegate.createElement) { node = this.delegate.createElement(nodeData.tagName) }
        if (!node) { node = doc.createElement(nodeData.tagName) }
        Object.keys(nodeData.attributes).forEach(function (name) {
          try {
            if (!_this.delegate || !_this.delegate.setAttribute || !_this.delegate.setAttribute(node, name, nodeData.attributes[name])) {
              node.setAttribute(name, nodeData.attributes[name])
            }
          } catch (e) {
            // Debug here if needed
          }
        })

        break
    }

    if (!node) {
      // throw node;
    }

    this.idMap[nodeData.id] = node

    if (parent) { parent.appendChild(node) }

    if (nodeData.childNodes) {
      for (var i = 0; i < nodeData.childNodes.length; i++) { this.deserializeNode(nodeData.childNodes[i], node) }
    }
    return node
  }
  return TreeMirror
})()

export { TreeMirror }



// WEBPACK FOOTER //
// ./src/components/watcheebox/tree-mirror.js